var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('td',{class:_vm.cellClass,style:({width:`${_vm.width}px`}),on:{"click":_vm.handleClick}},[_vm._v(" "+_vm._s(_vm.amount.toFixed(2))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }